import React from "react";
import { CS_TEL_HREF, CS_PHONE_DISPLAY } from "@/brand";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft } from "lucide-react";
import { Footer } from "@/components/layout/Footer";

// Shared shell for the two legal pages so headings, gutters, table-of-contents
// styling, and back-to-home affordances stay identical. Not exposed anywhere
// else — deliberately small.
export const LegalLayout = ({ title, subtitle, updated, seoDesc, children }) => (
  <div className="min-h-screen bg-[#040A0F] text-[#F6F1E4]">
    <Helmet>
      <title>{`${title} · Enchanted Gear Rentals`}</title>
      <meta name="description" content={seoDesc || subtitle} />
    </Helmet>
    <div className="border-b border-[#FFD166]/15 bg-[#040A0F]/95 backdrop-blur sticky top-0 z-20">
      <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="text-xs text-[#B9C8D5] hover:text-[#FFD166] inline-flex items-center gap-1.5" data-testid="legal-back-home">
          <ArrowLeft className="w-3 h-3" /> Back to Enchanted Gear Rentals
        </Link>
        <div className="text-[10px] uppercase tracking-[0.22em] text-[#B9C8D5]">Legal</div>
      </div>
    </div>
    <article className="max-w-3xl mx-auto px-6 py-14 prose-legal">
      <div className="eyebrow text-[#FFD166] mb-3">Legal · Enchanted Gear Rentals</div>
      <h1 className="font-serif text-4xl sm:text-5xl leading-tight text-[#F6F1E4]">{title}</h1>
      {subtitle && <p className="mt-3 text-lg text-[#B9C8D5] italic">{subtitle}</p>}
      <p className="mt-4 text-xs text-[#B9C8D5]">Last updated: {updated}</p>
      <div className="mt-10 space-y-8 text-[#F6F1E4]/90 leading-relaxed">
        {children}
      </div>
      <div className="mt-16 pt-6 border-t border-[#FFD166]/15 text-xs text-[#B9C8D5]">
        Questions about this document? Email{" "}
        <a href="mailto:info@enchantedgearrentals.com" className="text-[#FFD166] hover:underline">info@enchantedgearrentals.com</a>{" "}
        or call{" "}
        <a href={CS_TEL_HREF} className="text-[#FFD166] hover:underline">{CS_PHONE_DISPLAY}</a> (call or text).
      </div>
    </article>
    <Footer />
    <style>{`
      .prose-legal h2 { font-family: "Cormorant Garamond", serif; font-size: 1.75rem; color: #F6F1E4; margin-top: 2.5rem; margin-bottom: 0.75rem; letter-spacing: -0.01em; }
      .prose-legal h3 { font-size: 1.05rem; color: #FFD166; text-transform: uppercase; letter-spacing: 0.14em; margin-top: 1.75rem; margin-bottom: 0.5rem; font-weight: 600; }
      .prose-legal p { margin-bottom: 0.9rem; }
      .prose-legal ul { list-style: disc; padding-left: 1.25rem; margin-bottom: 1rem; }
      .prose-legal ul li { margin-bottom: 0.4rem; color: #F6F1E4; }
      .prose-legal ul li strong { color: #FFD166; }
      .prose-legal a { color: #FFD166; text-decoration: underline; text-underline-offset: 3px; }
      .prose-legal strong { color: #FFD166; }
      .prose-legal .callout { background: rgba(255,209,102,0.06); border: 1px solid rgba(255,209,102,0.25); border-radius: 12px; padding: 1rem 1.25rem; margin: 1.25rem 0; }
      .prose-legal .callout strong { display: block; margin-bottom: 0.35rem; color: #FFD166; letter-spacing: 0.05em; text-transform: uppercase; font-size: 0.7rem; }
    `}</style>
  </div>
);
